import { ReportFeatures } from '@hcs/types';

export const SUBJECT_PUBLIC_REMARKS_FEATURES = [
  ReportFeatures.SubjectListingRemarks,
];
